import { CoreTagType } from '@featuring-corp/components';
import { avatarColorType } from '@featuring-corp/components/dist/core-avatar/type';

const avatarColorList: avatarColorType[] = [
	'red',
	'orange',
	'yellow',
	'lightGreen',
	'green',
	'cyan',
	'teal',
	'lightBlue',
	'blue',
	'indigo',
	'purple',
	'magenta',
	'burgundy',
];

export const getAvatarColorType = (targetText?: string | number): avatarColorType => {
	if (!targetText) return 'gray';

	const charCode = typeof targetText === 'number' ? targetText : targetText.charCodeAt(0);
	const colorType = charCode % 13;

	return avatarColorList[colorType];
};

const tagColorList: CoreTagType[] = [
	'primary',
	'red',
	'orange',
	'lightGreen',
	'teal',
	'blue',
	'indigo',
	'magenta',
];

export const getTagColorType = (targetText?: string | number): CoreTagType => {
	if (!targetText) return 'gray';

	const charCode = typeof targetText === 'number' ? targetText : targetText.charCodeAt(0);
	const colorType = charCode % 8;

	return tagColorList[colorType];
};
